////STRIPE APPLE PAY
if (document.getElementById('payment-request-button')) {

    //variables
    const container = document.getElementById('requestContainer');

    const publicKey = container.dataset.stripePublicKey;
    const accountId = container.dataset.stripeAccountId;

    // the club
    const clubName = container.dataset.clubName;
    const clubPassesOnFee = parseInt(container.dataset.clubPassesOnFee) > 0;

    // the order
    const amount = parseInt(container.dataset.orderAmount);
    const feePassedOn = parseInt(container.dataset.passingOnFee);
    const orderId = parseInt(container.dataset.orderId);
    const orderName =
        'Order: ' + container.dataset.orderUuid + ' for ' + clubName;
    const countryCode = container.dataset.countryCode;
    const currency = container.dataset.countryCurrencyCode.toLowerCase();
    const containsSubsciptionBooking = (container.dataset.hasSubscriptionBookings
 == '1')

    const stripe = Stripe(publicKey, {
        // stripeAccount: accountId
    });

    function showForm(id) {
        document.getElementById(id).style.display = 'block';
    }

    function hideForm(id) {
        document.getElementById(id).style.display = 'none';
    }

    function makePaymentRequest(ev) {
        // Send the token to your server to charge it!
        var route = Routing.generate('api_v4_pay_order', {
            orderId: orderId,
            stripeToken: ev.token.id
        });

        return fetch(route, {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                stripeToken: ev.token.id,
                rememberCard: containsSubsciptionBooking ? '1' : '0',
                uniqueIdempotencyKey: container.dataset.orderUuid
            })
        });
    }

    function getItemsToDisplay() {
        if (clubPassesOnFee) {
            return [
                {
                    amount: amount,
                    label: 'Items'
                },
                {
                    amount: feePassedOn,
                    label: 'Platform Fee'
                }
            ];
        } else {
            return [];
        }
    }

    const payUsingStripe = document.getElementById('payUsingStripe');

    payUsingStripe.addEventListener(
        'click',
        function() {
            hideForm('payment-request-button');
            hideForm('payUsingStripe');
            showForm('old-card-form');
        },
        false
    );

    var paymentRequest = stripe.paymentRequest({
        country: countryCode,
        currency: currency,
        requestPayerName: true,
        total: {
            label: orderName,
            amount: clubPassesOnFee ? amount + feePassedOn : amount
        },
        displayItems: getItemsToDisplay()
    });

    const elements = stripe.elements();
    const prButton = elements.create('paymentRequestButton', {
        paymentRequest: paymentRequest
    });

    // Check the availability of the Payment Request API first.
    paymentRequest.canMakePayment().then(result => {

        if (result && (amount > 0 || containsSubsciptionBooking)) {
            if (!result.applePay) {
                showForm('non-apple-pay-helper');
            }

            hideForm('old-card-form');
            prButton.mount('#payment-request-button');

            showForm('payUsingStripe');
        } else {
            hideForm('payment-request-button');
            showForm('old-card-form');
        }
    });

    paymentRequest.on('token', function(ev) {
        makePaymentRequest(ev)
            .then(async response => {
                if (response.ok) {
                    // Report to the browser that the payment was successful, prompting
                    // it to close the browser payment interface.

                    const json = await response.json();

                    hideForm('payment-request-button');
                    document.getElementById(
                        'payment-request-succeeded'
                    ).style.display =
                        'block';

                    ev.complete('success');

                    location.reload();

                    $('#payment-request-button').html(
                        '<h2>Payment Successful!</h2>'
                    );
                } else {
                    // Report to the browser that the payment failed, prompting it to
                    // re-show the payment interface, or show an error message and close
                    // the payment interface.

                    if(response.status == 401) {
                        // using reload here instead of setting the location.href to '/login'
                        // because it will preserve the redirect
                        ev.complete('fail');
                        location.reload();
                    };

                    document.getElementById(
                        'payment-request-failed'
                    ).style.display =
                        'block';

                    hideForm('payment-request-button');
                    showForm('old-card-form');
                    ev.complete('fail');
                }
            })
            .catch(response => {
                showForm('old-card-form');
            });
    });
}
